import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import { fetchAlarmList, fetchStorePaymentAlarms, fetchStoreUnreadCounts, getAdminAlarmList } from "../utils/alarmService";

/**
 * 알림 Query Keys
 */
export const alarmKeys = {
  all: ["alarms"],
  list: (memberId) => [...alarmKeys.all, "list", memberId],
  unread: () => [...alarmKeys.all, "unread"],
  payment: () => [...alarmKeys.all, "payment"],
};

export const adminAlarmKeys = {
  all: ["adminAlarms"],
  list: () => [...adminAlarmKeys.all, "list"],
};

/**
 * 알림 목록을 조회하는 훅
 * @param {number} memberId - 회원 ID
 * @param {object} options - React Query 옵션
 * @returns {object} React Query 결과
 */
export const useAlarmList = (memberId, options = {}) => {
  return useQuery({
    queryKey: alarmKeys.list(memberId),
    queryFn: async () => {
      const page = await fetchAlarmList(memberId, 0);
      return page.content ?? [];
    },
    enabled: !!memberId,
    refetchInterval: 60000,
    ...options,
  });
};

export const useStoreUnreadCounts = (options = {}) => {
  return useQuery({
    queryKey: alarmKeys.unread(),
    queryFn: fetchStoreUnreadCounts,
    refetchInterval: 60000,
    ...options,
  });
};

export const useStorePaymentAlarms = (options = {}) => {
  return useQuery({
    queryKey: alarmKeys.payment(),
    queryFn: () => fetchStorePaymentAlarms(0, 20),
    ...options,
  });
};

export const alarmInfiniteKey = (memberId) => [...alarmKeys.list(memberId), "infinite"];

export const useAlarmInfiniteList = (memberId, category = "전체", options = {}) => {
  return useInfiniteQuery({
    queryKey: [...alarmInfiniteKey(memberId), category],
    queryFn: ({ pageParam }) => fetchAlarmList(memberId, pageParam, category),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => lastPage.last ? undefined : lastPage.number + 1,
    enabled: !!memberId,
    refetchInterval: 60000,
    ...options,
  });
};

export const useAdminAlarmInfiniteList = (options = {}) => {
  return useInfiniteQuery({
    queryKey: [...adminAlarmKeys.list(), "infinite"],
    queryFn: ({ pageParam }) => getAdminAlarmList(pageParam, 20),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => lastPage.last ? undefined : lastPage.number + 1,
    refetchInterval: 60000,
    ...options,
  });
};
